import { combineReducers } from 'redux';
import config from './modules/config/reducers';
import user from './modules/user/reducers';
import partner from './modules/partner/reducers';
import templates from './modules/templates/reducers';
import sites from './modules/sites/reducers';
import spinner from './modules/spinner/reducers/spinner';
import i18n from './modules/i18n/reducers';
import dialogs from './modules/dialogs/reducers';
import subscriptions from './modules/subscriptions/reducers';
import error from './modules/error/reducers';

const rootReducer = combineReducers({
  spinner,
  config: combineReducers(config),
  user: combineReducers(user),
  partner: partner.partnerData,
  templates: combineReducers(templates),
  sites: combineReducers(sites),
  i18n: combineReducers(i18n),
  dialogs: combineReducers(dialogs),
  subscriptions: combineReducers(subscriptions),
  error: combineReducers({
    criticalError: error.criticalError,
  }),
});

export default rootReducer;
